import React, { useCallback, useEffect } from 'react';
import { Bottom, Field, FormButton, Main } from './styles';
import Button from '../../button';
import {
  createProjectTemplate,
  dispatchSettingError,
  getProjectTemplateList,
  saveProjectTemplateDetails
} from '../../../services/settingServices';
import { isEmpty } from '../../../helpers/common';
import { trackAnalyticActivity } from '../../../services/analyticsService';
import { PROJECT_ANALYTICS } from '../../../global/analyticsConstants';
import { rootStore } from '../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { BUTTON_TYPE } from '../../../global/constants';
import ModalHeader from '../modalHeader';
import Input from '../../input';
import TextArea from '../../input/textArea';

interface Props {
  onCancel: () => void;
}
const CreateTemplateModal: React.FC<Props> = (props) => {
  const { onCancel } = props;
  //Mobx store variables
  const { projectTemplateStore, workspaceStore, settingStore } = rootStore;
  const { projectTemplateInput } = projectTemplateStore;
  const { currentWorkspace } = workspaceStore;
  const { loading } = settingStore;

  useEffect(() => {
    return () => {
      projectTemplateStore.setProjectTemplateInput(null);
    };
  }, [projectTemplateStore]);

  const onCloseModal = useCallback(() => {
    projectTemplateStore.setProjectTemplateInput(null);
    onCancel();
  }, [projectTemplateStore, onCancel]);

  const handleChangeDetails = useCallback(
    (propsName: string, value: string) => {
      projectTemplateStore.setProjectTemplateInput({ ...(projectTemplateInput || {}), [propsName]: value });
    },
    [projectTemplateInput, projectTemplateStore]
  );

  const onSubmit = useCallback(
    async (e: React.SyntheticEvent) => {
      try {
        e.preventDefault();
        if (isEmpty(projectTemplateInput?.name)) {
          dispatchSettingError('Please enter template name!');
          return;
        }
        let response;
        if (projectTemplateInput?.id) {
          response = await saveProjectTemplateDetails(projectTemplateInput);
          trackAnalyticActivity(PROJECT_ANALYTICS.TEMPLATE_UPDATED);
        } else {
          response = await createProjectTemplate(
            currentWorkspace?.id,
            projectTemplateInput?.name,
            projectTemplateInput?.description
          );
          trackAnalyticActivity(PROJECT_ANALYTICS.TEMPLATE_CREATED);
        }
        if (response) {
          onCloseModal();
          getProjectTemplateList(currentWorkspace?.id);
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    [projectTemplateInput, currentWorkspace?.id, onCloseModal]
  );

  return (
    <Main onSubmit={onSubmit}>
      <ModalHeader
        title={projectTemplateInput?.id ? 'Edit Project template' : 'Create Project template'}
        onClose={onCloseModal}
      />
      <Bottom>
        <Field>
          <Input
            label='Template Name'
            placeHolder='Enter template name '
            value={projectTemplateInput?.name}
            onChange={(e) => handleChangeDetails('name', e.target.value)}
          />
          <TextArea
            height='90px'
            label='Description'
            placeHolder='Enter description'
            value={projectTemplateInput?.description || ''}
            onChange={(e) => handleChangeDetails('description', e.target.value)}
          />
        </Field>
        <FormButton>
          <Button title='Cancel' variant={BUTTON_TYPE.SECONDARY} buttonType='button' onClick={onCloseModal} />
          <Button
            title={projectTemplateInput?.id ? 'Update' : 'Create'}
            variant={BUTTON_TYPE.PRIMARY}
            buttonType='submit'
            onClick={onSubmit}
            isLoading={loading}
            disabled={loading}
          />
        </FormButton>
      </Bottom>
    </Main>
  );
};
export default observer(CreateTemplateModal);
